import React from "react";

import { Button, Modal, ModalBody, ModalFooter, ModalHeading } from "@braze/beacon-core";

import { getFetchErrorModalAction } from "./utils/getFetchErrorModalAction";
import { FetchErrorModalBody } from "./FetchErrorModalBody";
import { FetchErrorModalTitle } from "./FetchErrorModalTitle";
import type { FetchErrorModalProps } from "./types";

/**
 * For server errors that require user notification and potentially actions, this modal is invoked by
 * the @lib/fetch `fetch` and `fetchWithRetry` functions.
 */
export const FetchErrorModal = ({ error, closeModal }: FetchErrorModalProps): React.ReactElement | null => {
  if (!error) {
    return null;
  }

  return (
    <Modal isOpen>
      <ModalHeading>
        <FetchErrorModalTitle error={error} />
      </ModalHeading>
      <ModalBody>
        <FetchErrorModalBody error={error} />
      </ModalBody>
      <ModalFooter>
        <Button
          onClick={() => {
            closeModal();
            getFetchErrorModalAction(error)();
          }}
        >
          OK
        </Button>
      </ModalFooter>
    </Modal>
  );
};
